<h2 class="rs-table-title">
  {{ "modem-choice.voip-title" | translate }}
</h2>
<ng-container *ngFor="let subscriberNumber of subscriberNumbers">
  <div class="rs-flex-row rs-flex-middle">
    <div class="rs-flex-column">
      <p class="rs-padding-bottom1 rs-txt-s3">
        {{ subscriberNumber }}
      </p>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <p class="rs-padding-bottom1 rs-txt-s3">
        <button
          class="rs-link-action rs-link-action-reset"
          (click)="onOpened(subscriberNumber)"
        >
          <span
            class="rs-link-action-label show-for-medium-up"
            aria-hidden="true"
          >
            {{ "modem-choice.voip-description" | translate }}
          </span>
          <span
            class="rs-action-link-icon"
            [title]="'modem-choice.voip-description' | translate"
          >
            <span class="show-for-sr">
              {{ "modem-choice.voip-description" | translate }}
            </span>
          </span>
        </button>
      </p>
    </div>
  </div>
  <hr class="rs-margin-bottom1" />
</ng-container>
